module.exports = __webpack_public_path__ + "img/no-light.df8edcb0.svg";